var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorreo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1550_2634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33716 9.8029C8.93909 10.0683 8.47672 10.2086 8 10.2086C7.52331 10.2086 7.06094 10.0683 6.66288 9.8029L0.106531 5.43187C0.0701562 5.40762 0.0347187 5.38234 0 5.35634V12.5187C0 13.3399 0.666406 13.9917 1.47291 13.9917H14.5271C15.3482 13.9917 16 13.3252 16 12.5187V5.35631C15.9652 5.38237 15.9297 5.40771 15.8932 5.432L9.33716 9.8029Z",
    fill: "#0D1116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.626562 4.65182L7.18291 9.02288C7.43109 9.18835 7.71553 9.27107 7.99997 9.27107C8.28444 9.27107 8.56891 9.18832 8.81709 9.02288L15.3734 4.65182C15.7658 4.39041 16 3.95291 16 3.48072C16 2.66882 15.3395 2.00832 14.5276 2.00832H1.47241C0.660531 2.00835 0 2.66885 0 3.4815C0 3.95291 0.23425 4.39041 0.626562 4.65182Z",
    fill: "#0D1116"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1550_2634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorreo);
export default __webpack_public_path__ + "static/media/correo.b8d4988929399aa380cdc7abab3ae774.svg";
export { ForwardRef as ReactComponent };